import React, { useState, useEffect, useCallback, useRef } from 'react';
import { format } from 'date-fns';
import { userService } from '../../_services';
import { Redirect } from "react-router-dom";
import ColorJson from '../../../src/whitelabel.json';
import { cn, safeParseDate } from '@/lib/utils';
import { Skeleton } from '@/components/ui/skeleton';
import FilterTagCom from '../FilterTag';

// New modern widget components
import BarListChart from '../BarListChart';
import ColumnPieChart from '../ColumnPieChart';
import ListChartWidget from '../ListChartWidget';

// Legacy components
import Claim from '../Claim';

function SubAdminDashboard({ dashboardName: propDashboardName, startDate: propStartDate, endDate: propEndDate, handeChangefilter, filterUpdateTrigger }) {
    // Get stored dates and user info
    const getInitialState = () => {
        const defaultStartDate = new Date();
        defaultStartDate.setDate(defaultStartDate.getDate() - 30);
        const defaultEndDate = new Date();
        
        const storedStartDate = localStorage.getItem('User_Start_Date');
        const storedEndDate = localStorage.getItem('User_End_Date');
        
        const startdate = (storedStartDate && storedStartDate !== "" && storedStartDate !== "null")
            ? safeParseDate(storedStartDate, defaultStartDate)
            : defaultStartDate;
        const enddate = (storedEndDate && storedEndDate !== "" && storedEndDate !== "null")
            ? safeParseDate(storedEndDate, defaultEndDate)
            : defaultEndDate;

        const filterdatalocal = localStorage.getItem('Advance_Filter');

        let roletype = '', rolename = '', whId = 0;
        try {
            const userdata = JSON.parse(localStorage.getItem('user'));
            if (userdata.userrole === "Distributor" && userdata.wholesaler === "Avenel") {
                roletype = "avdistributor";
                rolename = userdata.email;
                whId = userdata.wholesaler_Id;
            } else if (userdata.userrole === "Distributor" && userdata.wholesaler !== "Avenel") {
                roletype = "distributor";
                rolename = userdata.paramsname;
                whId = userdata.wholesaler_Id;
            } else {
                roletype = userdata.userrole;
                rolename = userdata.paramsname;
                whId = userdata.wholesaler_Id;
            }
        } catch (e) {}

        return {
            startdate, enddate, filterdatalocal, roletype, rolename, whId,
            userdata: JSON.parse(localStorage.getItem('user') || '{}')
        };
    };

    const initial = getInitialState();

    const [state, setState] = useState({
        userdata: initial.userdata,
        scrollArray: {},
        graphData: [],
        dashboardName: propDashboardName,
        endDate: format(initial.enddate, "yyyyMMdd"),
        startDate: format(initial.startdate, "yyyyMMdd"),
        FilterTagList: initial.filterdatalocal,
        roletype: initial.roletype,
        rolename: initial.rolename,
        wh_Id: initial.whId
    });

    // Get colors based on domain
    const getColors = useCallback(() => {
        const host = window.location.host.split('.').slice(-2).join('.').toLowerCase();
        const isRxHacker = host === "rxhacker.com" ||
                          host === "localhost:5464" ||
                          window.location.host.toLowerCase() === "tempfilter.23byt.es" ||
                          window.location.host.toLowerCase() === "reporting.nulifespanrx.com";

        if (isRxHacker) {
            return {
                primary: ColorJson.ApplicationColor.Rxhacker_primary_color,
                secondary: ColorJson.ApplicationColor.Rxhacker_secondary_color,
                extra: ColorJson.ApplicationColor.Rxhacker_extra_color
            };
        }
        return {
            primary: ColorJson.ApplicationColor.Glic_primary_color,
            secondary: ColorJson.ApplicationColor.Glic_secondary_color,
            extra: ColorJson.ApplicationColor.Glic_extra_color
        };
    }, []);

    // Build graph data
    const buildGraphData = useCallback(() => {
        const APIBaseURL = '/api/subadmin';
        const wname = "subadmin";
        const startDate = format(safeParseDate(propStartDate), "yyyyMMdd");
        const endDate = format(safeParseDate(propEndDate), "yyyyMMdd");

        let AdFilterJson = '';
        try {
            AdFilterJson = JSON.parse(localStorage.getItem('Advance_Filter'));
        } catch (e) {}

        const filterTagList = (AdFilterJson != null && AdFilterJson !== '' && AdFilterJson !== undefined && AdFilterJson !== "null")
            ? JSON.stringify(AdFilterJson)
            : '';

        const { primary: primaryColor, secondary: secondaryColor, extra: extraColor } = getColors();
        const filterTime = localStorage.getItem('Filter_Last_Update_Time');
        const hdType = localStorage.getItem('Updated_HD_Type');

        // Build request JSONs
        const buildRequestJson = (chartType, rcount = 30, extra = {}) => {
            return JSON.stringify({
                wname: String(state.userdata?.wholesaler_Id || ''),
                start_date: startDate,
                end_date: endDate,
                rcount,
                chart_type: chartType,
                filtertime: filterTime,
                rxsClaimType: hdType,
                ...extra
            });
        };

        const Column_PostData_RequestJson = buildRequestJson("columnList", 30, { ispatientsaving: "true", pharmacynumber: "all" });
        const PostData_RequestJson = buildRequestJson("pielist", 30);
        const PostData_PatientSaving_True = buildRequestJson("columnList", 30, { ispatientsaving: "true", pharmacynumber: "all" });
        const PostData_PatientSaving_False = buildRequestJson("columnList", 30, { ispatientsaving: "false", pharmacynumber: "all" });
        const PatientSavings_Pharmacy_RequestJson = buildRequestJson("list", 30);
        const Table_Pharmacy_RequestJson = buildRequestJson("list", 30);
        const TotalTransaction_PostData_RequestJson = buildRequestJson("columnList", 30, { ispatientsaving: "true", pharmacynumber: "all" });
        const Claim_PostData_RequestJson = buildRequestJson("list", 0);

        const graphData = [
            {
                url: APIBaseURL + "/total_transactions_new", type: "Bar_List", title: "Total Transactions",
                Subtitle: "Total number of transactions for each day", ColorCode: secondaryColor,
                DataType: "NA", XlabelString: "Date", YlabelString: "# of Transactions",
                interval: 'day', id: "WTotalTransaction", RequestJson: TotalTransaction_PostData_RequestJson, RequestJson1: JSON.stringify(AdFilterJson)
            },
            {
                url: APIBaseURL + "/ClaimCalculation", type: "Claim", title: "", Subtitle: "",
                ColorCode: extraColor, id: "RxSensClaim", RequestJson: Claim_PostData_RequestJson, RequestJson1: JSON.stringify(AdFilterJson)
            },
            {
                url: APIBaseURL + "/metric1a_new", type: "Bar_List", title: "Transactions by Group Number",
                Subtitle: "Number of transactions for each group number", ColorCode: secondaryColor,
                DataType: "GroupNumber", XlabelString: "Group Number", YlabelString: "# of Transactions",
                id: "WMetric1a", RequestJson: Column_PostData_RequestJson, RequestJson1: JSON.stringify(AdFilterJson)
            },
            {
                url: APIBaseURL + "/patient_savings_new", type: "Bar_List", title: "Average Patient Savings ($)",
                Subtitle: "Average savings for all patients in $", ColorCode: secondaryColor,
                DataType: "NA", XlabelString: "Date", YlabelString: "Average Savings",
                id: "WMetric3A", RequestJson: PostData_PatientSaving_True, RequestJson1: JSON.stringify(AdFilterJson)
            },
            {
                url: APIBaseURL + "/patient_savings_new", type: "Bar_List", title: "Average Patient Savings (%)",
                Subtitle: "Average savings for all patients in %", ColorCode: secondaryColor,
                DataType: "NA", XlabelString: "Date", YlabelString: "Average Savings",
                id: "WMetric3B", RequestJson: PostData_PatientSaving_False, RequestJson1: JSON.stringify(AdFilterJson)
            },
            {
                url: APIBaseURL + "/citytransaction_new", type: "Column_Pie", title: "Transactions by City",
                Subtitle: "Number of transactions in each city", XlabelString: "", YlabelString: "",
                ColorCode: extraColor, DataType: "PhCity", id: "CityTransaction",
                RequestJson: PostData_RequestJson, RequestJson1: JSON.stringify(AdFilterJson)
            },
            {
                url: APIBaseURL + "/pharmacy_transaction_new", type: "List", title: "Transactions by Pharmacy",
                Subtitle: "Number of transactions at each pharmacy", ColorCode: extraColor, DataType: "PharmacyName",
                XlabelString: "", YlabelString: "", id: "WPharmacyTransaction1",
                RequestJson: Table_Pharmacy_RequestJson, RequestJson1: JSON.stringify(AdFilterJson)
            },
            {
                url: APIBaseURL + "/statetransaction_new", type: "Column_Pie", title: "Transactions by State",
                Subtitle: "Number of transactions in each state", XlabelString: "States", YlabelString: "Number of Transactions",
                ColorCode: extraColor, DataType: "PhState", id: "WStateTransaction",
                RequestJson: PostData_RequestJson, RequestJson1: JSON.stringify(AdFilterJson)
            },
            {
                url: APIBaseURL + "/patientsavings_new", type: "List", title: "Patient Savings by Pharmacy",
                Subtitle: "Patient savings in $ at each pharmacy", ColorCode: extraColor, DataType: "PharmacyName",
                XlabelString: "", YlabelString: "", id: "WPatientSavingTransaction",
                RequestJson: PatientSavings_Pharmacy_RequestJson, RequestJson1: JSON.stringify(AdFilterJson)
            },
            {
                url: APIBaseURL + "/drugtransaction_new", type: "Column_Pie", title: "Transactions by Drug",
                Subtitle: "Number of transactions for each drug", ColorCode: extraColor,
                DataType: "DrugName", id: "WDrugTransaction",
                RequestJson: PostData_RequestJson, RequestJson1: JSON.stringify(AdFilterJson)
            },
            {
                url: APIBaseURL + "/top100groups", type: "List", title: "Transactions (Top 100)",
                DataType: "GroupName",
                Subtitle: "Transactions (Top 100)", ColorCode: extraColor, id: "top100groups",
                RequestJson: Table_Pharmacy_RequestJson, RequestJson1: JSON.stringify(AdFilterJson)
            },
            {
                url: APIBaseURL + "/whnametransaction_new", type: "Column_Pie", title: "Transactions by Wholesaler",
                Subtitle: "Number of transactions for each wholesaler", ColorCode: extraColor,
                DataType: "WholesalerName", id: "whnametransaction_new",
                RequestJson: PostData_RequestJson, RequestJson1: JSON.stringify(AdFilterJson)
            },
            {
                url: APIBaseURL + "/Repeat_Prescriptions_transaction_new", type: "List", title: "Transactions by Repeat Prescriptions",
                Subtitle: "Number of repeat prescriptions by each Prescriber", ColorCode: extraColor,
                DataType: "PrescriberName",
                XlabelString: "", YlabelString: "", id: "WRepeat_PrescriptionsTransaction",
                RequestJson: Table_Pharmacy_RequestJson, RequestJson1: JSON.stringify(AdFilterJson)
            }
        ];

        return { graphData, filterTagList, startDate, endDate, dashboardName: wname };
    }, [propStartDate, propEndDate, state.userdata, getColors]);

    // Change data handler
    const changeData = useCallback(() => {
        const result = buildGraphData();
        setState(prev => ({
            ...prev,
            graphData: result.graphData,
            FilterTagList: result.filterTagList,
            startDate: result.startDate,
            endDate: result.endDate,
            dashboardName: result.dashboardName
        }));
    }, [buildGraphData]);

    // Handle filter change
    const handlechangea = useCallback((e) => {
        
        if (e && e.heading && e.value) {
            // Validate heading is not undefined or invalid
            if (e.heading === 'undefined' || !e.heading) {

                return;
            }
            
            try {
                let Created_Advance_Filter = JSON.parse(localStorage.getItem('Advance_Filter')) || {};
                
                if (Created_Advance_Filter[e.heading]) {
                    if (!Created_Advance_Filter[e.heading].includes(e.value)) {
                        Created_Advance_Filter[e.heading].push(e.value);
                    }
                } else {
                    Created_Advance_Filter[e.heading] = [e.value];
                }
                
                localStorage.setItem('Advance_Filter', JSON.stringify(Created_Advance_Filter));
                localStorage.setItem('Filter_Last_Update_Time', new Date().toString());
                localStorage.setItem('Updated_AdFilter_Status', JSON.stringify(Created_Advance_Filter));
                
            } catch (error) {

            }
        }
        
        if (handeChangefilter) handeChangefilter(e);
    }, [handeChangefilter]);

    // Initialize on mount
    useEffect(() => {
        localStorage.setItem('Filter_Last_Update_Time', new Date().toString());
        changeData();
    }, []);

    // Check for filter/date changes
    useEffect(() => {
        if (!propStartDate || !propEndDate) return;
        const startDate = format(safeParseDate(propStartDate), "yyyyMMdd");
        const endDate = format(safeParseDate(propEndDate), "yyyyMMdd");

        let IsCall = false;
        try {
            const prevFilter = localStorage.getItem('Prev_Filter_Status')?.toLowerCase();
            const updatedFilter = localStorage.getItem('Updated_Filter_Status')?.toLowerCase();
            if (prevFilter !== updatedFilter || localStorage.getItem('Prev_AdFilter_Status') !== localStorage.getItem('Updated_AdFilter_Status') || localStorage.getItem('Prev_HD_Type') !== localStorage.getItem('Updated_HD_Type')) {
                IsCall = true;
            }
        } catch (e) {}

        if (endDate !== state.endDate || startDate !== state.startDate || IsCall) {
            if (IsCall) {
                localStorage.setItem('Prev_Filter_Status', localStorage.getItem('Updated_Filter_Status'));
                localStorage.setItem('Prev_AdFilter_Status', localStorage.getItem('Updated_AdFilter_Status'));
                localStorage.setItem('Prev_HD_Type', localStorage.getItem('Updated_HD_Type'));
            }
            changeData();
        }
    }, [propStartDate, propEndDate, state.startDate, state.endDate, changeData, filterUpdateTrigger]);

    // Check user permissions
    try {
        const usertype = userService.Get_User_Type();
        if (userService.Check_LoggedIn_Status() === 'Login') return <Redirect to="/login" />;
        if (usertype?.toLowerCase() === 'admin') return <Redirect to='/pageNotFound' />;
        if (usertype?.toLowerCase() === 'distributor') return <Redirect to='/pageNotFound' />;
        if (usertype?.toLowerCase() === 'wholesaler') return <Redirect to='/pageNotFound' />;
    } catch (e) {}

    const fullWidthTypes = ['WTotalTransaction', 'RxSensClaim', 'RxSensClaimNew', 'WPharmacyTransaction1', 'WPrescriberTransaction1', 'top100groups', 'WRepeat_PrescriptionsTransaction', 'whnametransaction_new', 'WDrugTransaction'];

    const renderWidgetContent = (item, index) => {
        switch (item.type) {
            // Modern widget components
            case "Bar_List":
                return <BarListChart data={item} key={"barlistgraph" + index} _Index={index} handlechangea={handlechangea} />;
            case "Column_Pie":
                return <ColumnPieChart data={item} key={"columnpiegraph" + index} _Index={index} handlechangea={handlechangea} />;
            case "List":
                return <ListChartWidget data={item} key={"listgraph" + index} _Index={index} handlechangea={handlechangea} />;
            
            // Legacy components
            case "Claim":
                return <Claim data={item} key={"claimbox" + index} _Index={index} />;
            default:
                return null;
        }
    };

    return (
        <div id="dashboard-container" className="space-y-6">
            <FilterTagCom Rolename={state.rolename} wh_Id={state.wh_Id} Roletype={state.roletype} df={state.startDate} dt={state.endDate} handlechangea={handlechangea} FilterTags={state.FilterTagList} />
            <div className="grid grid-cols-1 2xl:grid-cols-2 gap-3">
                {state.graphData.length === 0 ? (
                    Array.from({ length: 12 }).map((_, i) => (
                        <div key={"skeleton-" + i} className="min-h-[420px]">
                            <Skeleton className="h-full w-full rounded-xl" />
                        </div>
                    ))
                ) : (
                    state.graphData.map((item, index) => (
                        <div 
                            key={"graph-widget" + index} 
                            id={item.id + index} 
                            className={cn(
                                item.type !== "Claim" && item.type !== "Claim_New" && "min-h-[420px]",
                                fullWidthTypes.includes(item.id) && "2xl:col-span-2"
                            )}
                        >
                            {renderWidgetContent(item, index)}
                        </div>
                    ))
                )}
            </div>
        </div>
    );
}

export default SubAdminDashboard;
